module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("新增藥物群組"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('closeForm')
      }
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _c('hr'), _c('span', {
    staticClass: "errorMsg"
  }, [_vm._v(_vm._s(_vm.formMsg))]), _c('button', {
    staticClass: "btn btn-secondary float-right",
    attrs: {
      "disabled": _vm.formComplete === false
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createMedGroup($event)
      }
    }
  }, [_vm._v("新增")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("名稱*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e6c2abe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CreateDrugGroupForm.vue
// module id = 1529
// module chunks = 1